<fa-icon role="img" [icon]="faHandWave" [attr.aria-label]="'Raised hand' | translate"></fa-icon>
